import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import { createSelector } from 'reselect';
import { noop } from 'ui-components/default-props/noop';
import { emptyArray } from 'ui-components/default-props/empty';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';
import Global from '../../../../store/global-selectors';
import { SimpleDropdown } from '../../../simple-dropdown';
import { Confirmations } from '../../../../enums/confirmation';

import { get } from 'lodash-es';

const messages = defineMessages({
  defaultLabel: {
    description: 'confirmationDropdown.defaultLabel',
    defaultMessage: 'Confirmation',
    id: 'AP0seu',
  },
  defaultTitle: {
    description: 'confirmationDropdown.defaultTitle',
    defaultMessage: 'Select a Confirmation Type',
    id: 'yQ5C4G',
  },
});

const confirmationTypesSelector = (state) =>
  Global.selectBulkUpdateDrawerBulkUpdateProperty(state, {
    property: 'confirmationTypes',
  }) || emptyArray;
const confirmationsSelector = createSelector(confirmationTypesSelector, (confirmations) =>
  confirmations.map((item) => ({
    key: item.confirmationId,
    name: item.name,
  })),
);
const confirmationTypesEnumSelector = createSelector(
  (confirmationEnums) => confirmationEnums,
  (confirmationEnums) =>
    Object.values(confirmationEnums).map(({ messageDescriptor }, ordinal) => ({
      key: ordinal.toString(),
      name: <FormattedMessage {...messageDescriptor} />,
    })),
);

const shouldUseConfirmationEnums = (job, rateBrowserModalId) => {
  const bulkAction = get(job, 'bulkActions[0]', emptyArray);
  const confirmationString = 'confirmation';
  const isConfirmationSelectedinBulkModal = bulkAction.name === confirmationString;
  return rateBrowserModalId || isConfirmationSelectedinBulkModal;
};

export const ConfirmationDropdown = ({
  dropdownMenuShouldHaveWidthOfButton = false,
  onConfirmationSelected = noop,
  required = false,
  selectedConfirmation = '',
  labelMessage = null,
  hasError = false,
}) => {
  const rateBrowserModalId = useSelector(Global.selectRateBrowsergetModalId);
  const lastAddedJobId = useSelector(Global.selectBulkUpdateLastAddedJobId);
  const job = useSelector((state) =>
    Global.selectBulkUpdateBulkUpdateJob(state, {
      bulkUpdateJobId: lastAddedJobId,
    }),
  );
  const confirmationsFromState = useSelector(confirmationsSelector);
  const items = shouldUseConfirmationEnums(job, rateBrowserModalId)
    ? confirmationTypesEnumSelector(Confirmations)
    : confirmationsFromState || emptyArray;

  const labelDescriptor = labelMessage || messages.defaultLabel;
  const label = <FormattedMessage {...labelDescriptor} />;

  const defaultTitle = <FormattedMessage {...messages.defaultTitle} />;

  return (
    <SimpleDropdown
      defaultTitle={defaultTitle}
      dropdownMenuShouldHaveWidthOfButton={dropdownMenuShouldHaveWidthOfButton}
      hasError={hasError}
      items={items}
      label={label}
      onItemSelected={onConfirmationSelected}
      required={required}
      selectedItemKey={selectedConfirmation}
    />
  );
};

ConfirmationDropdown.propTypes = {
  dropdownMenuShouldHaveWidthOfButton: PropTypes.bool,
  onConfirmationSelected: PropTypes.func,
  required: PropTypes.bool,
  selectedConfirmation: PropTypes.string,
  hasError: PropTypes.bool,
  labelMessage: MessageDescriptorPropType,
};
